module.exports = __webpack_public_path__ + "static/media/some_features.ac3073ba.svg";